import { NotificationTypeEnum } from 'modules/notification/constants/notification.enum';

export interface FileAttachment {
  type: string;
  url: string;
  filename: string;
}

export interface INotification {
  _id: string;
  title: string;
  type: NOTIFICATION_TYPE;
  notificationKind: NotificationTypeEnum;
  message: string;
  data: INotificationData;
  executedBy?: {
    email: string;
    fullName: string
    _id: string
  },
  important: boolean;
  createdAt: string;
  viewed?: boolean;
}

export interface INotificationData {
  _id: string;
  id?: string;
  name: string;
  code?: string;
  email?: string;
  path?: string;
  orderId?: string;
  orderCode?: string;
  incidence?: { _id: string; code: string } | null;
  owner?: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: {
      thumb: string;
      url: string;
      width: number;
      height: number;
      sizes: any[];
      _id: string;
    };
  };
  firstName?: string;
  lastName?: string;
  isSystem?: boolean;
  file?: FileAttachment;
  category?: string;
}

export enum NOTIFICATION_TYPE {
  NEW_LOGISTIC_PROVIDER = 'NEW_LOGISTIC_PROVIDER',
  NEW_PRODUCT_PROVIDER = 'NEW_PRODUCT_PROVIDER',
  EXPRESS_DELIVERY_ACTIVE = 'EXPRESS_DELIVERY_ACTIVE',
  INVITATION_ACCEPTANCE = 'INVITATION_ACCEPTANCE',
  USER_CREATED = 'USER_CREATED',
  USER_ASSIGNED = 'USER_ASSIGNED',
  USER_UNASSIGNED = 'USER_UNASSIGNED',
  USER_UPDATED = 'USER_UPDATED',
  USER_DELETED = 'USER_DELETED',
  SUPPLIER_CREATE = 'SUPPLIER_CREATE',
  MANUFACTURE_CREATE = 'MANUFACTURE_CREATE',
  LOGISTIC_PROVIDER_CREATE = 'LOGISTIC-PROVIDER_CREATE',
  DISTRIBUTION_CENTER_CREATE = 'DISTRIBUTION_CENTER_CREATE',
  WAREHOUSE_CREATE = 'WAREHOUSE_CREATE',
  CATEGORY_CREATE = 'CATEGORY_CREATE',
  EXPORT_DONE = 'EXPORT_DONE',
  EXPORT_FAILED = 'ERROR',
  RECOVERY_PAID_CANCELLED_ORDER = 'RECOVERY_PAID_CANCELLED_ORDER'
}

export interface IExportData {
  _id: string;
  path: string;
  name?: string;
  data: Record<string, unknown>;
  executedBy?: {
    email: string;
    fullName: string;
    _id: string;
  };
  createdAt: string;
}
